(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const banners = document.querySelectorAll('[data-seasonal-alert]')
    if (!banners.length) return

    const formatCountdown = (targetDate) => {
      const target = new Date(targetDate).getTime()
      if (Number.isNaN(target)) return ''
      const remaining = target - Date.now()
      if (remaining <= 0) return '0d 00h 00m'

      const totalMinutes = Math.floor(remaining / 60000)
      const days = Math.floor(totalMinutes / 1440)
      const hours = Math.floor((totalMinutes % 1440) / 60)
      const minutes = totalMinutes % 60
      return `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m`
    }

    const applyStorefrontHiddenOffsets = () => {
      document.documentElement.style.setProperty('--seasonal-alert-height', '0px')
      document.documentElement.style.setProperty('--seasonal-alert-offset', '0px')
    }

    banners.forEach((banner) => {
      const isStorefrontHidden = banner.hasAttribute('data-storefront-hidden')
      if (isStorefrontHidden) {
        applyStorefrontHiddenOffsets()
        return
      }

      const sectionId = banner.dataset.sectionId
      const dismissKey = `seasonal-alert-dismissed:${sectionId}`
      const isSessionDismissed = sessionStorage.getItem(dismissKey) === '1'

      const closeButton = banner.querySelector('[data-alert-close]')
      const countdownEl = banner.querySelector('[data-countdown]')
      const deadline = countdownEl?.dataset.deadline

      if (deadline) {
        const updateCountdown = () => {
          const value = formatCountdown(deadline)
          const prefix = countdownEl.dataset.prefix || ''
          countdownEl.textContent = value ? `${prefix} ${value}`.trim() : ''
        }
        updateCountdown()
        setInterval(updateCountdown, 30000)
      }

      const inner = banner.querySelector('.seasonal-alert__inner')
      const syncBannerWithScroll = () => {
        if (banner.hidden) return
        if (isStorefrontHidden) {
          applyStorefrontHiddenOffsets()
          return
        }

        const fullHeight = inner ? inner.offsetHeight : banner.offsetHeight
        const scrollY = Math.max(window.scrollY, 0)
        const hiddenHeight = Math.min(scrollY, fullHeight)

        banner.style.transform = `translateY(-${hiddenHeight}px)`

        const anchor = inner || banner
        const bottom = Math.max(anchor.getBoundingClientRect().bottom, 0)
        document.documentElement.style.setProperty('--seasonal-alert-offset', `${Math.round(bottom)}px`)
        document.documentElement.style.setProperty('--seasonal-alert-height', `${fullHeight}px`)
      }

      if (isSessionDismissed) {
        banner.hidden = true
        banner.style.transform = 'translateY(-100%)'
        document.documentElement.style.setProperty('--seasonal-alert-height', '0px')
        document.documentElement.style.setProperty('--seasonal-alert-offset', '0px')
        return
      }

      closeButton?.addEventListener('click', () => {
        sessionStorage.setItem(dismissKey, '1')
        banner.hidden = true
        banner.style.transform = 'translateY(-100%)'
        document.documentElement.style.setProperty('--seasonal-alert-height', '0px')
        document.documentElement.style.setProperty('--seasonal-alert-offset', '0px')
      })

      const onScroll = () => {
        syncBannerWithScroll()
      }
      window.addEventListener('scroll', onScroll, { passive: true })
      window.addEventListener('resize', syncBannerWithScroll)
      if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(syncBannerWithScroll)
        resizeObserver.observe(banner)
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(syncBannerWithScroll)
      })
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const mobileQuery = window.matchMedia('(max-width: 899px)');

    function syncFooterMenuAccordions() {
      document.querySelectorAll('.site-footer__menu-accordion').forEach((accordion) => {
        if (mobileQuery.matches) {
          return;
        }
        accordion.open = true;
      });
    }

    function initFooterMenuAccordions() {
      document.querySelectorAll('.site-footer__menu-accordion').forEach((accordion) => {
        accordion.open = !mobileQuery.matches;
      });
    }

    initFooterMenuAccordions();
    mobileQuery.addEventListener('change', syncFooterMenuAccordions);
  })();

  } catch(e) { console.error(e); }
})();
})();
